// extracted by mini-css-extract-plugin
export default {"wrapper":"planPaymentRestriction_wrapper__xRyaB","titleText":"planPaymentRestriction_titleText__Kpl-k"};